<template>
  <div :class="getItemTableContainerClass">
    <ItemTable
      ref="itemTable"
      v-bind="itemTableProps"
      data-test-id="commandRunnerItemTable"
    />
  </div>
</template>

<script>
import {
  ItemTableConsts,
  ItemTypeConsts,
  ItemTypeDisplayNames,
  StoreModuleMap,
} from 'client/util/Constants';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';
import ItemTableComputedMixin from 'client/components/ItemTable/mixins/ItemTableComputedMixin';
import ItemTableMethodsMixin from 'client/components/ItemTable/mixins/ItemTableMethodsMixin';
import ItemTablePropsMixin from 'client/components/ItemTable/mixins/ItemTablePropsMixin';
import pluralize from 'pluralize';

const { columnTypes } = ItemTableConsts;

export default {
  name: 'CommandRunnerItemTable',

  components: {
    ItemTable,
  },

  mixins: [
    ItemTableComputedMixin,
    ItemTableMethodsMixin,
    ItemTablePropsMixin,
  ],

  props: {
    itemType: {
      required: true,
      type: String,
    },
  },

  computed: {
    itemTableProps() {
      return {
        boundItemsUrl: this.boundItemsUrl,
        columns: [
          {
            classNames: {
              body: [columnTypes.emailColumn],
              heading: [columnTypes.emailColumn],
            },
            dataField: 'email',
            headingText: 'Email',
            sortBy: 'email',
          },
        ],
        hasSelectColumn: true,
        itemType: this.itemType,
        keepFresh: typeof window.mocha === 'undefined'
          && this.inMainPanel,
        selectionItemText: {
          label: 'selected',
          plural: pluralize(ItemTypeDisplayNames[this.itemType]),
          singular: ItemTypeDisplayNames[this.itemType],
        },
        showBound: false,
        storeModule: StoreModuleMap[ItemTypeConsts.commandRunner],
      };
    },
  },
};
</script>
